let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6bAEH")).then(() => parcelRequire('4wZkc'));